var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upcoming"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6 11.7797L16.19 10.3718L19.75 6.82715L21.16 8.23503C21.05 8.26498 17.6 11.7797 17.6 11.7797ZM13 3.98145H11V8.97391H13V3.98145ZM6.4 11.7797L7.81 10.3718L4.26 6.81717L2.84 8.23503C2.95 8.26498 6.4 11.7797 6.4 11.7797ZM20 14.9649H16.58C15.81 16.7222 14.04 17.9603 12 17.9603C9.96 17.9603 8.19 16.7222 7.42 14.9649H4V19.9573H20V14.9649ZM20 12.9679C21.1 12.9679 22 13.8665 22 14.9649V19.9573C22 21.0557 21.1 21.9543 20 21.9543H4C2.9 21.9543 2 21.0557 2 19.9573V14.9649C2 13.8665 2.9 12.9679 4 12.9679H9C9 14.6254 10.34 15.9634 12 15.9634C13.66 15.9634 15 14.6254 15 12.9679H20Z",
    fill: "#457EFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.dacbf95e4a2b75f2b90499e5d7963472.svg";
export { ForwardRef as ReactComponent };